import { http } from 'Utils/http';
import { STATUSES } from 'Utils/constants';
import { getRecaptchaToken } from 'Components/ReCaptcha';

export const subscribeEmail = async (email) => {
    const captchaToken = await getRecaptchaToken('email_subscribe').catch(() => null);
    const payload = { email, captchaToken, captchaAction: 'email_subscribe' };
    let status = STATUSES.SUCCESS;
    return http.post('/api/email/subscribe', payload)
        .then(res => {
            if (res?.status === -1 && res?.globalErrorMessageList?.length > 0) {
                const err = new Error(res.globalErrorMessageList[0]);
                err.globalErrorMessageList = res.globalErrorMessageList;
                return Promise.reject(err);
            }
            return Promise.resolve({ status, data: res });
        })
        .catch(error => {
            status = STATUSES.ERROR;
            return Promise.reject({ status, data: error });
        });
};

export const unsubscribeEmail = async (email, unSubscribeReasons) => {
    const captchaToken = await getRecaptchaToken('email_unsubscribe').catch(() => null);
    const payload = { email, unSubscribeReasons, captchaToken, captchaAction: 'email_unsubscribe' };
    let status = STATUSES.SUCCESS;
    return http.post('/api/email/unsubscribe', payload)
        .then(res => {
            if (res?.status === -1 && res?.globalErrorMessageList?.length > 0) {
                const err = new Error(res.globalErrorMessageList[0]);
                err.globalErrorMessageList = res.globalErrorMessageList;
                return Promise.reject(err);
            }
            return Promise.resolve({ status, data: res });
        })
        .catch(error => {
            status = STATUSES.ERROR;
            return Promise.reject({ status, data: error });
        });
};

export const verifySubscribeEmail = async (tokenValue) => {
    let status = STATUSES.SUCCESS;
    return http.post('/api/email/verifySubscribe', { tokenValue })
        .then(res => Promise.resolve({ status, data: res }))
        .catch(error => {
            status = STATUSES.ERROR;
            return Promise.reject({ status, data: error });
        });
};

export const verifyUnsubscribeEmail = async (tokenValue) => {
    let status = STATUSES.SUCCESS;
    return http.post('/api/email/verifyUnsubscribe', { tokenValue })
        .then(res => Promise.resolve({ status, data: res }))
        .catch(error => {
            status = STATUSES.ERROR;
            return Promise.reject({ status, data: error });
        });
};
